import { useRef, useState, useEffect } from 'react';
import { Platform, AppState as RNAppState } from 'react-native';
export var AppState;
(function (AppState) {
    AppState["ACTIVE"] = "active";
    AppState["INACTIVE"] = "inactive";
    AppState["BACKGROUND"] = "background";
})(AppState || (AppState = {}));
export var AppTransitionState;
(function (AppTransitionState) {
    AppTransitionState[AppTransitionState["TO_FOREGROUND"] = 0] = "TO_FOREGROUND";
    AppTransitionState[AppTransitionState["TO_BACKGROUND"] = 1] = "TO_BACKGROUND";
})(AppTransitionState || (AppTransitionState = {}));
export const appStateTransitionResolver = (currentState, nextState) => {
    if ([AppState.INACTIVE, AppState.BACKGROUND].includes(currentState) &&
        nextState === AppState.ACTIVE) {
        return AppTransitionState.TO_FOREGROUND;
    }
    else if ([AppState.INACTIVE, AppState.BACKGROUND].includes(nextState) &&
        currentState === AppState.ACTIVE) {
        return AppTransitionState.TO_BACKGROUND;
    }
    else if (currentState === AppState.INACTIVE && nextState === AppState.BACKGROUND) {
        return AppTransitionState.TO_BACKGROUND;
    }
    return null;
};
export const useAppTransitionState = () => {
    const appState = useRef(RNAppState.currentState);
    const [transitionState, setTransitionState] = useState(null);
    useEffect(() => {
        const listener = RNAppState.addEventListener("change", _handleAppStateChange);
        let webRemoveListener;
        if (Platform.OS === "web") {
            const handleVisibilityChange = () => {
                if (document.hidden && appState.current !== AppState.BACKGROUND) {
                    _handleAppStateChange(AppState.BACKGROUND);
                }
                else if (!document.hidden && appState.current !== AppState.ACTIVE) {
                    _handleAppStateChange(AppState.ACTIVE);
                }
            };
            document.addEventListener("visibilitychange", handleVisibilityChange);
            webRemoveListener = () => document.removeEventListener("visibilitychange", handleVisibilityChange);
        }
        return () => {
            listener.remove();
            webRemoveListener && webRemoveListener();
        };
    }, []);
    const _handleAppStateChange = (nextAppState) => {
        const transition = appStateTransitionResolver(appState.current, nextAppState);
        setTransitionState(transition);
        appState.current = nextAppState;
    };
    return transitionState;
};
//# sourceMappingURL=useAppTransitionState.js.map